<template>
  <div class="welcome">
    <div style="padding-top: 10%;">
      <img style="width:30%" :src="GLOBAL.imgserve+'/welcome/homeImg.png'" alt="">
      </div>
    <div @click="goPage('/Home')" class="btn" style="color:#ff9800;font-weight: 600;margin-top: 30px;margin-bottom: 30px;">- ENTER -</div>
  </div>
</template>

<script>
export default {
  

methods:{
      goPage(pagePath) {
      console.log(pagePath);
      this.$router.push(pagePath).catch((err) => {});
    },
}

}
</script>


<style >
.welcome{
  width: 100%;
  height: 100%;
  margin: 0;
  /* position:absolute; */
}  



</style>